module.exports = __webpack_public_path__ + "962fcf5d4d0876a0ad5f8ce82a100e38.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/Prior.png
// module id = YTjR
// module chunks = 0